export default __webpack_public_path__ + "static/5-5ae2aa6b443465ae51a7616ab3a97c3a.jpeg";